export const styles = theme => ({
  '&': {
    lineHeight: '23px'
  },
  '& h2': {
    fontSize: 15,
    fontWeight: 500
  },
  // Large images: fit to full width
  // Small images: keep original size, center horizontally
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    margin: '0 auto'
  },
  '& table': {
    fontSize: '0.875rem',
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
    border: '1px solid #d2d2d2',
    borderCollapse: 'collapse',
    marginBottom: 14,
    '& th': {
      border: '1px solid #d2d2d2',
      borderCollapse: 'collapse',
      textAlign: 'left',
      padding: 4,
      backgroundColor: '#e6e6e6',
      '& code:first-child, & code:last-child': {
        margin: 0
      }
    },
    '& td': {
      border: '1px solid #d2d2d2',
      borderCollapse: 'collapse',
      padding: 4,
      '& code:first-child, & code:last-child': {
        margin: 0
      }
    },
    '& tbody tr:nth-child(even)': {
      backgroundColor: '#f0f0f0'
    }
  }
});

export default theme => ({
  root: {
    ...styles(theme)
  }
});
